import { render, staticRenderFns } from "./LeagueGamePublic.vue?vue&type=template&id=ae90322e&scoped=true&"
import script from "./LeagueGamePublic.vue?vue&type=script&lang=js&"
export * from "./LeagueGamePublic.vue?vue&type=script&lang=js&"
import style0 from "./LeagueGamePublic.vue?vue&type=style&index=0&id=ae90322e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae90322e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
